import SpinnerLoading from '../../../components/SpinnerLoading'
import Modal from '../../../components/Modal'
import Alert from '../../../components/Alert'
import { useEffect, useState } from 'react'
import { API, Auth } from 'aws-amplify'
import { FaRegCheckCircle } from 'react-icons/fa'

const CheckingResult = {
  INIT: 0,
  UP_TO_DATE: 1,
  NEW_VERSION_AVAILABLE: 2,
  ERROR: 3
}
const CheckLatestVersion = ({ show, handleClose }) => {
  const curentVersion = 'c9ed51c'

  const [loading, setLoading] = useState(true)
  const [latestVersion, setLatestVersion] = useState('')
  const [checkVersionStatus, setCheckVersionStatus] = useState(CheckingResult.INIT)

  useEffect(() => {
    const fetchCheckLatestVersion = async () => {
      try {
        const session = await Auth.currentSession()
        const idToken = session.idToken.jwtToken
        const getInit = {
          headers: { "Content-Type": "application/json", "Authorization": idToken }
        }
        const apiName = process.env.REACT_APP_REST_API_NAME
        const result = await API.get(apiName, `/check_latest_version`, getInit)
        setLatestVersion(result.version)
        setCheckVersionStatus(result.version === curentVersion ? 
          CheckingResult.UP_TO_DATE : CheckingResult.NEW_VERSION_AVAILABLE)
      } catch (error) {
        console.log(error)
        setCheckVersionStatus(CheckingResult.ERROR)
      }
      setLoading(false)
    }
    fetchCheckLatestVersion()
  }, [])

  const displayMessage = (checkVersionStatus) => {
    if (checkVersionStatus === CheckingResult.INIT) {
      return 'กำลังตรวจสอบ...'
    }
    if (checkVersionStatus === CheckingResult.UP_TO_DATE) {
      return <Alert variant='success' styles='mt-3 items-center gap-2'>
        <FaRegCheckCircle /> โปรแกรมนี้เป็นเวอร์ชันล่าสุดแล้ว : {latestVersion}
      </Alert>
    }
    if (checkVersionStatus === CheckingResult.NEW_VERSION_AVAILABLE) {
      return <Alert variant='warning' styles='mt-3 items-center gap-2'>
        พบโปรแกรมเวอร์ชันใหม่ : {latestVersion}
        <button className="ml-2 btn-success" onClick={reLaunchApp}>อัพเดต</button>
      </Alert>
    }
    return <Alert variant='danger' styles='mt-3 items-center'>
      เกิดข้อผิดพลาด กรุณาลองอีกครั้ง
    </Alert>
  }

  const reLaunchApp = async () => {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration && registration.waiting) {
      const waitingWorker = registration && registration.waiting
      waitingWorker && waitingWorker.postMessage({ type: 'SKIP_WAITING' })
    }
    handleClose()
    window.location.reload()
  }

  return <Modal show={show} onHide={handleClose}
    title="ตรวจสอบ Version ล่าสุดของ App"
    cancelText='ปิด'>
    <div className="flex flex-col items-center justify-center gap-2">
      {loading ? <SpinnerLoading /> : null}
      {displayMessage(checkVersionStatus)}
    </div>
  </Modal>
}

export default CheckLatestVersion